<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

withDefaults(
  defineProps<{
    isMutating: boolean;
    errorMessage: string | null;
    confirmDisabled?: boolean;
  }>(),
  { confirmDisabled: false }
);

const emit = defineEmits<{
  'submit-missing': [];
  'open-spot-picker': [];
  'confirm-location': [];
}>();
</script>

<template>
  <div v-bind="$attrs">
    <v-alert
      v-if="errorMessage"
      type="error"
      variant="tonal"
      density="compact"
      class="mx-4 mt-4 mb-0 typography-body-sm"
      :text="errorMessage" />

    <button
      v-ripple
      type="button"
      class="wizard-option d-flex align-center gap-4 px-4 py-4 w-100"
      :class="{ 'opacity-50': isMutating || confirmDisabled }"
      :disabled="isMutating || confirmDisabled"
      data-testid="wizard-option-confirmed"
      @click="emit('confirm-location')">
      <v-progress-circular v-if="isMutating" indeterminate size="24" color="primary" />
      <v-icon v-else size="24" color="success" icon="mdi-map-marker-check" />
      <span class="typography-body-md">{{ t('assetCheckWizard.step1.locationConfirmed') }}</span>
    </button>

    <v-divider />

    <button
      v-ripple
      type="button"
      class="wizard-option d-flex align-center gap-4 px-4 py-4 w-100"
      :class="{ 'opacity-50': isMutating }"
      :disabled="isMutating"
      data-testid="wizard-option-missing"
      @click="emit('submit-missing')">
      <v-progress-circular v-if="isMutating" indeterminate size="24" color="primary" />
      <v-icon v-else size="24" color="error" icon="mdi-map-marker-remove-variant" />
      <span class="typography-body-md">{{ t('assetCheckWizard.step1.missingFromYard') }}</span>
    </button>

    <v-divider />

    <button
      v-ripple
      type="button"
      class="wizard-option d-flex align-center gap-4 px-4 py-4 w-100"
      :class="{ 'opacity-50': isMutating }"
      :disabled="isMutating"
      data-testid="wizard-option-update-location"
      @click="emit('open-spot-picker')">
      <v-progress-circular v-if="isMutating" indeterminate size="24" color="primary" />
      <v-icon v-else size="24" icon="mdi-swap-horizontal" />
      <span class="typography-body-md">{{ t('assetCheckWizard.step1.updateLocation') }}</span>
    </button>
  </div>
</template>

<style scoped>
.wizard-option {
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
}

.wizard-option:disabled {
  cursor: not-allowed;
}
</style>
